import { instance } from "../Settings/instance";
import { endpoints } from "../Settings/endpoints";

export const getUserId = async (params, success, error) => {
  instance.get(endpoints.GET_USER_ID+'/?x-customerid='+params).then((res) => {
    success(res);
  }).catch((err) => {
    error(err);
  });
}

export const userSession = (params, success, error) => {
  instance.post(endpoints.USER_SESSION, params).then((res) => {
    success(res);
  }).catch((err) => {
    error(err);
  });
}

export const getPermittedUsers = async (success, error) => {
  instance.get(endpoints.GET_PERMITTED_USERS).then((res) => {
    success(res);
  }).catch((err) => {
    error(err);
  });
}